import React, { FC } from 'react'
import './character-count.css'

// UTILITIES
import { flatten } from '../../../utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLLabelElement> {
    label?: string
    max?: number
}

const CharacterCount: FC<Props> = (props) => {
    const { className: classProps, label, max, ...labelProps } = props
    const className = flatten("char-count", classProps)

    return (
        <label className={className} {...labelProps}>
            <p className="text-body-2"> {`${label?.length}/${max}`}</p>
        </label>
    )
}

export default CharacterCount